import { CardHeader } from "../../../components/CardHeader";
import { useFormContext } from "react-hook-form";
import { EditImageSelector } from "./image-modal/EditImageSelector";
import { ChallengeImageWrapper } from "./ChallengeImageWrapper";
import { useUploadImage } from "../../../service/api";
import { ImagePreview } from "./ImagePreview";
import { ExternalLinkButton } from "../../../components/ExternalLinkButton";
import { colors } from "../../../components/colors";
import { IMAGE_GUIDE_LINK } from "../../common/hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

type Props = {
  isEdit: boolean;
};

export const ChallengeImageSection = ({ isEdit }: Props) => {
  const { watch, setValue } = useFormContext();
  const files = watch("files");
  const { mutateAsync: uploadImage, isLoading } = useUploadImage();

  const fileOnChange = async (acceptedFiles: File[]) => {
    setValue("files", acceptedFiles);
  };

  return (
    <div className="card">
      <CardHeader title="Challenge image" subtitle="Upload challenge image.">
        <ExternalLinkButton
          width="fit-content"
          textColor={colors.textPrimary}
          href={IMAGE_GUIDE_LINK}
          backgroundColor={colors.transparent}
          hoverColor={colors.ctaLight}
          text="Image guide"
          icon={<FontAwesomeIcon icon={solid("arrow-up-right-from-square")} />}
        />
        {isEdit && (
          <EditImageSelector
            imageUploadIsLoading={isLoading}
            uploadImage={uploadImage}
            modalHeader="Edit image for this challenge"
          />
        )}
      </CardHeader>
      <div className="card-body">
        {!isEdit && (
          <ChallengeImageWrapper
            file={files && files[0]}
            onDrop={fileOnChange}
          />
        )}
        {isEdit && <ImagePreview />}
      </div>
    </div>
  );
};
